import styled from "styled-components";

export const Container = styled.div`
    /* width: 300px; */
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;

    background-color: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    border-radius: 4px;

    box-shadow: 0 10px 30px rgba(0,0,0,0.3);

    /* transform: translateX(400px);
    opacity: 0;
    transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);

    .toast.show {
        transform: translateX(0);
        opacity: 1;
    } */
`;

export const Body = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
`;

export const Button = styled.button`
    background-color: transparent;

    &.open-sale {
        display: flex;
        align-items: center;
        gap: 4px;
        background-color: ${(props) => props.theme.colors.success};
        color: ${(props) => props.theme.colors.white};
        padding: 5px 10px;
        border-radius: 4px;
    }
`;

export const Content = styled.div``;

export const ContentProgress = styled.div`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    width: 100%;
    height: 4px;
    overflow: hidden;
`;

export const Head = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;

    svg{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
`;

export const Footer = styled.footer`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
`;

export const HeadLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;

    &.active{
        svg{
            color: ${(props) => props.theme.colors.success};
        }
    }
    
    &.erro{
        svg{
            color: ${(props) => props.theme.colors.error};
        }
    }
    
    &.attention{
        svg{
            color: ${(props) => props.theme.colors.warning};
        }
    }
`;

export const Infor = styled.div``;

export const ProgressBar = styled.div`
    border-radius: 4px;
    height: 100%;
    
    width: 0%;
    transition: width 0.1s linear;

    &.active{
        background-color: ${(props) => props.theme.colors.success};
    }
    
    &.erro{
        background-color: ${(props) => props.theme.colors.error};
    }
    
    &.attention{
        background-color: ${(props) => props.theme.colors.warning};
    }
`;

export const SubTitle = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_500};
    font-size: 14px;

    padding: 10px 15px;
`;

export const Title = styled.p`
    font-weight: 500;
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray.gray_800};
`;